import {
  AbidoShakerPNG,
  WeQuickPayPNG,
  ZaptrancePNG,
  ManagePNG,
  URLShortenerPNG,
  IPTrackerPNG,
  LendSqrFePNG,
  InteractiveCommentsPNG,
  CertivaPNG,
  CraftNexusLogo,
  URLRedirectorPNG,
  ZipLnkPng,
  RebelAIPic,
} from "../shared/assets";
import { technologies } from "./constants";
import { ProjectTag } from "./enum";

export const projects = [
  {
    imgURL: RebelAIPic,
    name: "RebelAI - AI-Powered Chat Application",
    description: `A full-stack AI chat web application built with modern technologies. It
features a sleek, customizable chat UI where users can interact with an
intelligent assistant. It runs on deepseek v3.1 free model and uses
openrouter.ai for accessing the model. The backend is powered by NestJS`,
    technologies: [
      technologies.Nestjs,
      technologies.Mongo,
      technologies.NextJs,
      technologies.GoogleAuth,
      technologies.Tailwind,
    ],
    liveURL: "https://rebel-chat-bot.vercel.app/",
    srcCodeURL: "",
    tag: [ProjectTag.FullStack, ProjectTag.Personal],
  },
  {
    imgURL: ZipLnkPng,
    name: "Ziplnk.xyz - URL Shortening web service",
    // description:
    //   "Short links, big impact! Tired of long, messy URLs that break in emails and look unprofessional? Welcome to Ziplnk – the powerful, intuitive, and completely free URL shortening service designed to make sharing links easier and more effective than ever before.",
    description:
      "Ziplnk.xyz is a full-stack URL shortening service built for simplicity and reliability. It transforms long, cumbersome URLs into short, manageable links that are perfect for clean sharing in emails, social media, and marketing materials. Built with a modern tech stack including Next.js, NestJS, and MongoDB.",
    technologies: [
      technologies.JavaScript,
      technologies.API,
      technologies.Nestjs,
      technologies.Mongo,
      technologies.NextJs,
      technologies.Tailwind,
    ],
    liveURL: "https://ziplnk.xyz",
    srcCodeURL: "",
    tag: [ProjectTag.FullStack],
  },
  {
    imgURL: URLRedirectorPNG,
    name: "Tab Redirector - Open URLs in New Tabs",
    description:
      "Quickly redirect any URL to another domain while preserving paths, queries, and hashes—now opening in new tabs by default. Perfect for developers testing across environments (local/staging/prod) without losing the original page. Saves frequently used domains for one-click access. Lightweight, privacy-focused, and Chrome Web Store compliant.",
    technologies: [technologies.JavaScript, technologies.API],
    liveURL:
      "https://chromewebstore.google.com/detail/jbiihbnondbllokhkafjgfodahkphdad?utm_source=item-share-cb",
    srcCodeURL: "https://github.com/chiefcipher/url-redirector-extension",
    tag: [ProjectTag.ChromeExtension, ProjectTag.Frontend],
  },
  {
    imgURL: CertivaPNG,
    name: "Certiva Backend Fix #9",
    description:
      "A backend fix for Certiva issue #9 using Nestjs, TypeOrm, PostgreSQL and Typescript. Built an authentication system for admins with Email OTP Verification, JWT and bcrypt for secure user authentication.",
    technologies: [
      technologies.Nestjs,
      technologies.Typescript,
      technologies.TypeOrm,
      technologies.PostgreSQL,
    ],
    // liveURL: "https://abidoshaker.xyz/",
    srcCodeURL: "https://github.com/JayWebtech/certiva_backend",
    tag: [ProjectTag.OpenSource, ProjectTag.Backend],
  },

  {
    imgURL: AbidoShakerPNG,
    name: "Abidoshaker web app",
    description:
      "A web app that allows users to create accounts with custom links from their usernames, share those links, and receive random anonymous messages. 🤫",
    technologies: [
      technologies.Typescript,
      technologies.React,
      technologies.Node,
      technologies.Mongo,
      technologies.Express,
      technologies.Tailwind,
      technologies.Git,
    ],
    liveURL: "https://abidoshaker.xyz/",
    srcCodeURL: "private",
    tag: [ProjectTag.FullStack],
  },
  {
    imgURL: CraftNexusLogo,
    name: "CraftNexus Fix #5",
    description:
      "A fix for CraftNexus issue #5 using React, Tailwind and Typescript. Built a responsive, modern navigation bar as per figma design.",
    technologies: [
      technologies.Typescript,
      technologies.React,
      technologies.Tailwind,
    ],
    // liveURL: "https://abidoshaker.xyz/",
    srcCodeURL: "https://github.com/EvolutionalHub/CraftNexus",
    tag: [ProjectTag.OpenSource, ProjectTag.Frontend],
  },
  {
    imgURL: WeQuickPayPNG,
    name: "WeQuickPay landing page",
    description:
      "A landing page for the 'We Quick Pay' application guides users on how to install the app, enabling them to make fast and secure payments with just one quick scan.",
    technologies: [
      technologies.React,
      technologies.API,
      technologies.SCSS,
      technologies.Git,
    ],
    liveURL: "https://wequickpay.netlify.app/",
    srcCodeURL: "private",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: ZaptrancePNG,
    name: "Zaptrance landing page",
    description:
      "A captivating landing page showcasing 'Zaptrance,' a company driven by the vision of becoming the foremost IT and digital service provider in Nigeria.",
    technologies: [
      technologies.React,
      technologies.Typescript,
      technologies.API,
      technologies.SCSS,
      technologies.Git,
    ],
    liveURL: "https://zaptrance.netlify.app/",
    srcCodeURL: "private",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: ManagePNG,
    name: "Manage Landing Page",
    description:
      "A catchy, responsive landing page made with HTML5, SCSS and JavaScript. It was a challenge from frontend mentor.",
    technologies: [
      technologies.HTML,
      technologies.SCSS,
      technologies.JavaScript,
    ],
    liveURL: "https://chiefcipher.github.io/manage-landing-page-master/",
    srcCodeURL: "https://github.com/chiefcipher/manage-landing-page-master",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: LendSqrFePNG,
    name: "Lendsqr Frontend Test",
    description: "MY SOLUTION TO LENDSQR FULL STACK ENGINEER ASSESSMENT",
    technologies: [
      technologies.React,
      technologies.Typescript,
      technologies.SCSS,
      technologies.Git,
    ],
    liveURL: "https://samuel-yakubu-ohiani-lendsqr-fe-test.netlify.app/",
    srcCodeURL: "https://github.com/chiefcipher/lendsqr-fe-test",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: InteractiveCommentsPNG,
    name: "Interactive Comments",
    description:
      "An interactive comment web app.Supports features like upvote, downvote, comments, replies, sorting by votes and timestamps.",
    technologies: [
      technologies.React,
      technologies.SCSS,
      technologies.LocalStorage,
    ],
    liveURL: "https://chiefcipher.github.io/interactive-comments/",
    srcCodeURL: "https://github.com/chiefcipher/interactive-comments",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: URLShortenerPNG,
    name: "URL Shortener",
    description:
      "A url shortening web app. Uses api from shrt.de to convert inputed URLs into their short form.",
    technologies: [
      technologies.React,
      technologies.SCSS,
      technologies.JavaScript,
      technologies.API,
    ],
    liveURL: "https://chiefcipher.github.io/url-shortener/",
    srcCodeURL: "https://github.com/chiefcipher/url-shortener",
    tag: [ProjectTag.Frontend],
  },
  {
    imgURL: IPTrackerPNG,
    name: "Ip Address Tracker",
    description:
      "An IP address tracker made with HTML,SCSS and vanilla js, works with apis from https://api.mapbox.com and https://geo.ipify.org",
    technologies: [
      technologies.HTML,
      technologies.SCSS,
      technologies.JavaScript,
    ],
    liveURL: "https://chiefcipher.github.io/ip-address-tracker/",
    srcCodeURL: "https://github.com/chiefcipher/ip-address-tracker",
    tag: [ProjectTag.Frontend],
  },
  {
    name: "Foodlie landing page",
    description:
      "A landing page introducing Foodlie, an app designed to streamline meal ordering while delivering an exceptional user experience.",
    technologies: [
      technologies.React,
      technologies.API,
      technologies.SCSS,
      technologies.Git,
    ],
    liveURL: "https://foodlie.com.ng/",
    srcCodeURL: "private",
    tag: [ProjectTag.Frontend],
  },
  {
    name: "Natours API",
    description:
      "A web application built after using the course from the Node.js, Express, MongoDB & More The Complete Bootcamp by Jonas Schmedtmann",
    technologies: [
      technologies.Node,
      technologies.Express,
      technologies.Mongo,
      technologies.Stripe,
    ],
    // liveURL: "",
    srcCodeURL: "https://github.com/chiefcipher/natours",
    tag: [ProjectTag.Backend],
  },
];
